// extracted by mini-css-extract-plugin
export var cardTitle = "_cq-1";
export var commentBubble = "_cq-e";
export var commentForm = "_cq-a";
export var commentInput = "_cq-b";
export var commentLabel = "_cq-d";
export var commentPrompt = "_cq-9";
export var csatCard = "_cq-0";
export var feedbackSection = "_cq-7";
export var starDisabled = "_cq-6";
export var starEmpty = "_cq-5";
export var starFilled = "_cq-4";
export var starWrapper = "_cq-3";
export var starsContainer = "_cq-2";
export var submittedComment = "_cq-c";
export var thankYouText = "_cq-8";